module.exports = __webpack_public_path__ + "assets/workbench-3.acdb5ec5.svg";